module.exports = __webpack_public_path__ + "static/media/Pheasant-Hills-Northville-ByLaws.87a09149.pdf";